import { useQuery } from '@tanstack/react-query';
import React from 'react';
import { useNavigate } from 'react-router';
import { useTerminalClient } from '../client-rpc-router';
import { TerminalListRow } from '../components/TerminalListRow';
import { TerminalScreen } from '../components/TerminalScreen';
import { useNumberParam, useNumberQueryParam } from '../helpers';

export default function InboundQueuesPage() {
	const client = useTerminalClient();
	const documentTypeId = useNumberParam('documentTypeId');
	const parentId = useNumberQueryParam('parentId');
	const navigate = useNavigate();

	const { data: queues, isLoading } = useQuery({
		queryKey: ['inbound-queues', documentTypeId, parentId],
		queryFn: () => client.inboundDeliveryOrderProcess.inboundQueueGetAllForMeQuery.execute({ documentTypeId: documentTypeId!, parentId }),
		enabled: !!documentTypeId
	});

	return (
		<TerminalScreen showBackButton topBar={<div>Fronty příjmu</div>}>
			<div className="flex flex-col gap-2">
				{queues ? (
					queues.length === 0 ? (
						<div className="p-6 text-center text-muted-foreground">Žádné fronty</div>
					) : (
						queues.map(queue => <InboundQueueRow key={queue.id} label={queue.name} documentTypeId={documentTypeId!} id={queue.id} isFolder={queue.isFolder} />)
					)
				) : null}
			</div>
		</TerminalScreen>
	);
}

const InboundQueueRow = React.memo(({ label, documentTypeId, id, isFolder }: { label: string; documentTypeId: number; id: number; isFolder: boolean }) => {
	const navigate = useNavigate();
	const client = useTerminalClient();

	const { data: count, isLoading } = useQuery({
		queryKey: ['inbound-queue-count', id],
		queryFn: () => client.inboundDeliveryOrderProcess.countInboundDeliveryOrdersByQueueQuery.execute({ queueId: id })
	});

	const goToQueue = () => {
		if (isFolder) {
			navigate(`/inbound/${documentTypeId}/queues?parentId=${id}`);
		} else {
			navigate(`/inbound/${documentTypeId}/queues/${id}`);
		}
	};

	return <TerminalListRow label={label} count={count} isLoading={isLoading} onClick={goToQueue} />;
});
